
<div id="print-section">
  <p class="title h4">Elenco Richieste</p>

  <app-filter (filtersSubmitted)="onFiltersChanged($event)" [filters]="filters"></app-filter>

  <it-table striped="true" itSort (sortChange)="sortData($event)">
    <ng-container thead>
      <tr>
        <th it-sort-header="lastOwnership" scope="col">Data cambio competenza</th>
        <th it-sort-header="code" scope="col">N Pratica</th>
        <th it-sort-header="patientSurnameAndName" scope="col">Paziente</th>
        <th it-sort-header="ownershipCode" scope="col">Competenza</th>
        <th it-sort-header="settingCode" scope="col">Setting</th>
        <th scope="col">Entità segnalante</th>
        <th scope="col">Entità mittente</th>
        <th it-sort-header="statusCode" scope="col">Stato</th>
        <th it-sort-header="notification" scope="col" class="text-center no-print">Notifiche</th>
        <th it-sort-header="lastNote" scope="col" class="text-center no-print">Aggiornata il</th>
        <th scope="col" class="text-center no-print">Dettaglio</th>
      </tr>
    </ng-container>

    <ng-container tbody>
      <tr *ngFor="let request of requests" class="align-middle">
        <td>{{ request.ownership.changeDate | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <span *ngIf="request.code" tooltipPlacement="right" [itTooltip]="request.code">
            {{ request.code.length > 30 ? (request.code | slice:0:30) + '...' : request.code }}
          </span>
        </td>
        <td>{{ request?.patient?.name }} {{ request?.patient?.surname }}<br>{{ request?.patient?.fiscalCode }}</td>
        <td>{{ request?.ownership?.name }}</td>
        <td>{{ request?.setting?.name }}</td>
        <td>{{ request.creator?.name }}</td>
        <td>{{ request.sender?.name }}</td>
        <td>
          <span [itBadge]="getBadgeColor(request.status.code)" [rounded]="'true'"
          class="d-inline-block w-100 text-center">
            {{ request?.status?.name }}
          </span>
        </td>
        <td class="text-center no-print">
          {{ request?.notificationToReadNumber }}/{{ request?.notificationNumber }}
        </td>
        <td class="text-center no-print">
          <ng-container *ngIf="request?.substatus">
                <a
                  tabindex="0"
                  role="button"
                  triggers="focus"
                  [itTooltip]="getSubstatusesText(request.substatus)">
                  <it-icon name="warning-circle" size="sm" color="warning"></it-icon>
                </a>
          </ng-container>
          <a [itTooltip]="(request.lastNote?.insertUser?.code ? request.lastNote?.insertUser?.code : ' ') + ' ' + (request.lastNote?.title ? request.lastNote?.title : ' ') + ' ' + (request.lastNote?.type?.name ? request.lastNote?.type?.name : ' ') + ' ' + (request.lastNote?.text ? request.lastNote?.text : 'Creazione pratica')">{{ request?.lastNote?.insertDate | date: 'dd/MM/yyyy HH:mm'}}</a>
        </td>
        <td class="p-0 text-center no-print">
          <a
            class="d-block px-2 py-2 text-decoration-none"
            (click)="navigateToRequest(request.uuid)"
          >
            <it-icon name="file" size="sm" color="primary" class="clickable-icon"></it-icon>
          </a>
        </td>
      </tr>
    </ng-container>

    <ng-container caption>
      <small>
        Risultati <strong>{{ startIndex }}</strong> -
        <strong>{{ endIndex }}</strong> di <strong>{{ total }}</strong>
      </small></ng-container
    >
  </it-table>
</div>
    
<div class="row">
  <div class="col-sm-4">
    <button ngxPrint printSectionId="print-section" [printTitle]="'Elenco richieste'" [useExistingCss]="true" itButton="outline-primary" size="xs">
      <it-icon [name]="'file-pdf'" size="xs" color="primary"></it-icon> Stampa risultati
    </button>
  </div>
  <div class="col">
    <it-pagination
    *ngIf="totalPages > 0"
    alignment="end"
    [pageNumbers]="totalPages"
    [currentPage]="this.filters.page!"
    [currentChanger]="this.filters.size"
    (changerEvent)="changerEvent($event)"
    (pageEvent)="onPageChange($event)"
    ></it-pagination>
  </div>
</div>


